/**
 * PERFORMANCE OPTIMIZATIONS UTILITY
 * Conditional loading and intersection observer for better performance
 */

// Error handling for Shopify Analytics
const shopifyAnalyticsErrorHandler = {
  init: function() {
    // Intercepter les erreurs de tracking vidéo
    const originalConsoleError = console.error;
    console.error = function(...args) {
      const errorMessage = args.join(' ');
      
      // Filtrer les erreurs de producer-errors.js et retry-middleware.js
      if (errorMessage.includes('producer-errors.js') || 
          errorMessage.includes('retry-middleware.js') ||
          errorMessage.includes('online_store_media_video_progress') ||
          errorMessage.includes('Failed to fetch')) {
        console.warn('🎥 Erreur de tracking vidéo Shopify interceptée et supprimée:', errorMessage);
        return; // Ne pas afficher l'erreur
      }
      
      // Laisser passer les autres erreurs
      originalConsoleError.apply(console, args);
    };
    
    // Gestionnaire d'erreurs global pour les promesses non gérées
    window.addEventListener('unhandledrejection', function(event) {
      if (event.reason && 
          (event.reason.message?.includes('producer-errors') ||
           event.reason.message?.includes('retry-middleware') ||
           event.reason.message?.includes('Failed to fetch'))) {
        console.warn('🎥 Promesse rejetée pour tracking vidéo supprimée');
        event.preventDefault();
      }
    });
  },
  
  // Patch pour désactiver le tracking vidéo problématique
  disableVideoTracking: function() {
    if (typeof window !== 'undefined' && window.Shopify?.analytics) {
      const originalTrack = window.Shopify.analytics.track;
      
      window.Shopify.analytics.track = function(eventName, payload) {
        // Bloquer les événements de tracking vidéo
        if (eventName?.includes('video') || 
            payload?.schemaId?.includes('video')) {
          console.log('🚫 Tracking vidéo désactivé:', eventName);
          return Promise.resolve();
        }
        
        // Laisser passer les autres événements
        return originalTrack.apply(this, arguments);
      };
    }
  }
};

// Intersection Observer for lazy loading elements
const createObserver = (callback, options = {}) => {
  const defaultOptions = {
    root: null,
    rootMargin: '50px',
    threshold: 0.1
  };
  
  return new IntersectionObserver(callback, { ...defaultOptions, ...options });
};

// Conditional script loader
const conditionalScriptLoader = {
  // Load scripts only when specific conditions are met
  loadOnCondition: function(condition, scriptSrc, callback) {
    if (condition()) {
      this.loadScript(scriptSrc, callback);
    }
  },
  
  loadScript: function(src, callback) {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    if (callback) script.onload = callback;
    document.head.appendChild(script);
  },
  
  // Load scripts only when user interacts
  loadOnInteraction: function(scriptSrc, events = ['click', 'scroll', 'keydown']) {
    const loadScript = () => {
      this.loadScript(scriptSrc);
      events.forEach(event => {
        window.removeEventListener(event, loadScript);
      });
    };
    
    events.forEach(event => {
      window.addEventListener(event, loadScript, { passive: true, once: true });
    });
  }
};

// Initialiser les gestionnaires d'erreur dès que possible
document.addEventListener('DOMContentLoaded', function() {
  shopifyAnalyticsErrorHandler.init();
  shopifyAnalyticsErrorHandler.disableVideoTracking();
});

// Export for use in other scripts
window.performanceUtils = {
  createObserver,
  conditionalScriptLoader,
  shopifyAnalyticsErrorHandler
};